<template>
  <b-card>
    <b-alert
      v-if="errorText"
      show
      variant="danger"
    >
      <div class="alert-body">
        {{ errorText }}
      </div>
    </b-alert>

    <b-form
      class="mb-2"
      @submit.prevent="search"
    >
      <b-row>
        <b-col
          md="6"
          lg="3"
        >
          <b-form-group label="Платёж ЮKassa">
            <b-form-input v-model="filters.externalOrderId" />
          </b-form-group>
        </b-col>
        <b-col
          md="6"
          lg="3"
        >
          <b-form-group label="Номер заказа">
            <b-form-input v-model="filters.internalOrderId" />
          </b-form-group>
        </b-col>
        <b-col
          md="6"
          lg="3"
        >
          <b-form-group label="Событие">
            <b-form-input
              v-model="filters.event"
              placeholder="webhook.declined"
            />
          </b-form-group>
        </b-col>
        <b-col
          md="3"
          lg="1"
        >
          <b-form-group label="Уровень">
            <b-form-select
              v-model="filters.level"
              :options="levelOptions"
            />
          </b-form-group>
        </b-col>
        <b-col
          md="3"
          lg="2"
        >
          <b-form-group label="Источник">
            <b-form-select
              v-model="filters.source"
              :options="sourceOptions"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-button
        type="submit"
        variant="primary"
        class="mr-1"
      >
        Показать
      </b-button>
      <b-button
        variant="outline-secondary"
        @click="reset"
      >
        Сбросить
      </b-button>
    </b-form>

    <payment-events-table
      :rows="rows"
      :count="count"
      :page="page"
      :per-page="perPage"
      :loading="loading"
      show-payment
      @page="changePage"
    />
  </b-card>
</template>

<script>
import {
  BAlert, BButton, BCard, BCol, BForm, BFormGroup, BFormInput, BFormSelect, BRow,
} from 'bootstrap-vue'
import paymentAdminApi from '@/services/payment-admin-api.service'
import PaymentEventsTable from './components/PaymentEventsTable.vue'
import { errorMessage } from './payment-labels'

const PER_PAGE = 50
const emptyFilters = () => ({
  externalOrderId: '', internalOrderId: '', event: '', level: '', source: '',
})

export default {
  name: 'PaymentEventsPage',
  components: {
    BAlert,
    BButton,
    BCard,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BRow,
    PaymentEventsTable,
  },
  data() {
    return {
      filters: { ...emptyFilters(), ...this.$route.query },
      rows: [],
      count: 0,
      page: 1,
      perPage: PER_PAGE,
      loading: false,
      errorText: '',
      levelOptions: ['', 'error', 'warn', 'info', 'debug'].map(value => ({ value, text: value || 'Любой' })),
      sourceOptions: ['', 'webhook', 'api', 'system', 'admin'].map(value => ({ value, text: value || 'Любой' })),
    }
  },
  created() {
    this.fetch()
  },
  methods: {
    search() {
      this.page = 1
      this.fetch()
    },
    reset() {
      this.filters = emptyFilters()
      this.search()
    },
    changePage(page) {
      this.page = page
      this.fetch()
    },
    async fetch() {
      this.loading = true
      this.errorText = ''
      try {
        const { data } = await paymentAdminApi.events({
          ...this.filters,
          skipCount: (this.page - 1) * this.perPage,
          maxResultCount: this.perPage,
        })
        this.rows = data.rows || []
        this.count = data.count || 0
      } catch (e) {
        this.errorText = errorMessage(e)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
